import {mockUp} from "./mockup";
import {renderLoadmoreItem} from "./renderLoadmore";
import 'ion-rangeslider';
import qs from "qs";

export function initLoadmore(observer) {
    const AJAX_MODE = 'dev';
    //0 - кнопка показать варианты
    //1 - изменение данных в блоке подбор квартиры
    //2 - кнопка показать ещё (дозагрузка)

    const LOADMORE_CONFIG = {
        '0': {
            offset: 8,
            remains: 4,
            url: '/api/searchRooms/',
        },
        '1': {
            url: '/api/searchRooms/'
        },
        '2': {
            offset: 8,
            remains: 4,
            url: '/api/searchRooms/'
        },
    }

    const $searchWrapper = $('[data-loadmore]');
    const $loadMorePreloader = $('#loadmore_preloader');
    const $loadMoreButton = $('[data-loadmore-button]');
    const $searchButton = $('[data-start-search]');
    const $sortButton = $('#sort_button');
    const $findBar = $('.find-bar');


    if (!$searchWrapper.length) return;

    const loadMoreType = $searchWrapper.data('search-wrapper');
    let isLoad = false;

    init();

    function init() {

        $loadMoreButton.on('click',function (){
            const $parent = $(this).parent();
            $(this).addClass('hide');
            $('.preloaer').removeClass('hide')
            setTimeout(function (){
                renderElements()
                $parent.addClass('hide')
            }, 1000)
        })

    }

    function renderElements() {

        $.ajax({
            url: LOADMORE_CONFIG.url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            success: (data) => {
                if (data.result && data.result.length) {
                    successFn(data);
                } else {
                    errorFn();
                }
            },
            error: (data) => {
                errorFn(data);
            },
        });
    }


    function successFn(data) {
        renderResult(data);
    }

    function errorFn(data) {
        if (AJAX_MODE === 'dev') {
            data = mockUp[0];
            successFn(data);
            return
        }

    }

    function renderResult(data) {
        const result = renderLoadmoreItem(data);
        $searchWrapper.append(result);
        observer.observe();
    }

    function hidePreloader() {
        $loadMorePreloader.addClass('hide');

    }

    function hideButtonPreloader(){
        $loadMoreButton.addClass('hide');
    }

    function showButtonPreLoader() {
        $loadMoreButton.removeClass('hide');
    }

    function showPreloader() {
        $loadMorePreloader.removeClass('hide');
        $loadMoreButton.removeClass('hide');
    }

}